module.exports = __webpack_public_path__ + "6b7e9f310e05482fc808039cc2f26596.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/notification/images/warning.png
 ** module id = 1196
 ** module chunks = 0
 **/